import { render, staticRenderFns } from "./ResourseCategory.vue?vue&type=template&id=43f582f0&scoped=true"
import script from "./ResourseCategory.vue?vue&type=script&lang=js"
export * from "./ResourseCategory.vue?vue&type=script&lang=js"
import style0 from "./ResourseCategory.vue?vue&type=style&index=0&id=43f582f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f582f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VImg,VSkeletonLoader})
